import { createContext, useContext } from 'react';

const NotificationContext = createContext({ addNotification: () => {} });

export const useNotificationContext = () => {
  return useContext(NotificationContext);
};

// TODO NotificationContextProvider

export default NotificationContext;
